import { render, staticRenderFns } from "./CreateOrEdit.vue?vue&type=template&id=286d56cb&scoped=true"
import script from "./CreateOrEdit.vue?vue&type=script&lang=ts"
export * from "./CreateOrEdit.vue?vue&type=script&lang=ts"
import style0 from "./CreateOrEdit.vue?vue&type=style&index=0&id=286d56cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286d56cb",
  null
  
)

export default component.exports